// extracted by mini-css-extract-plugin
module.exports = {"notScroll":"notScroll_notScroll__1bA9S","notScrollStrong":"notScroll_notScrollStrong__2dFmW"};